export const hasErrorStatusCode = (item) => (item.status_code >= 400);

export const statusCodeBadgeColor = (item) => (hasErrorStatusCode(item) ? 'bg-soft-danger' : 'bg-soft-success');
